import React, { useRef, useState } from 'react';
import { Row, Col } from 'react-bootstrap';

export const Mentions = () => {


  return (
    <div className='contact-container'>
      <div className='banner-titre'>
        <h1 className='contact-titre'> Mentions Légales </h1>
      </div>
      <div className='single-container'>
        <h2>Éditeur du site</h2>
        <p>Nom de votre entreprise</p>
        <p>Adresse de votre entreprise</p>
        <p>Téléphone de votre entreprise</p>
        <p>Adresse e-mail de contact</p>
        <p>Numéro d'identification de votre entreprise</p>

        <h2>Directeur de la publication</h2>
        <p>Nom du directeur de la publication</p>

        <h2>Hébergeur du site</h2>
        <p>Nom de l'hébergeur</p>
        <p>Adresse de l'hébergeur</p>
        <p>Téléphone de l'hébergeur</p>
        <p>E-mail de l'hébergeur</p>

        <h2>Propriété intellectuelle</h2>
        <p>Ce site et son contenu sont la propriété de [Nom de votre entreprise] et sont protégés par les lois sur la propriété intellectuelle. Toute utilisation non autorisée du contenu de ce site, y compris la reproduction, la distribution ou la diffusion, est strictement interdite.</p>

        <h2>Protection des données personnelles</h2>
        <p>[Incluez ici une politique de confidentialité détaillée expliquant comment vous collectez, stockez et traitez les données personnelles des utilisateurs.]</p>

        <h2>Cookies</h2>
        <p>[Incluez ici une politique sur l'utilisation des cookies et comment les utilisateurs peuvent les gérer.]</p>

        <h2>Liens externes</h2>
        <p>Ce site peut contenir des liens vers des sites web tiers. [Nom de votre entreprise] n'est pas responsable du contenu ou de la politique de confidentialité de ces sites tiers.</p>

        <h2>Responsabilité</h2>
        <p>[Expliquez ici la limitation de votre responsabilité en cas d'erreurs ou d'omissions sur le site.]</p>

        <h2>Droit applicable et juridiction compétente</h2>
        <p>Ce site est soumis aux lois [indiquez la juridiction applicable]. Tout litige relatif à l'utilisation de ce site sera de la compétence exclusive des tribunaux de [indiquez la juridiction compétente].</p>
      </div>
    </div>

  );
}

